export const commentBg = [
    {
        bg: '#FF9999',
        focus: '#FFC2C2',
        text: '#311111',
        iconColor: '#E56B75',
        iconLight: '#F37474',
        light: '#FFE0E0'
    },
    {
        bg: '#FDDD93',
        focus: '#FEEBBE',
        text: '#463118',
        iconColor: '#78552B',
        iconLight: '#F6B563',
        light: '#FFF5C9'
    },
    {
        bg: '#AFFFBA',
        focus: '#CFFFD6',
        text: '#123526',
        iconColor: '#2B7849',
        iconLight: '#6AE698',
        light: '#C6FFE9'
    },
    {
        bg: '#FBB6A6',
        focus: '#FFDBCE',
        text: '#381C13',
        iconColor: '#764B2B',
        iconLight: '#E7856B',
        light: '#FFDCC6'
    },
    {
        bg: '#FCC0FB',
        focus: '#FFCFFA',
        text: '#381333',
        iconColor: '#752A70',
        iconLight: '#E066DB',
        light: '#FFC6FF'
    },
    {
        bg: '#DDC5EF',
        focus: '#EACFFF',
        text: '#2B1337',
        iconColor: '#532A75',
        iconLight: '#BA69E5',
        light: '#E4C5FF'
    },
    {
        bg: '#B6D9FF',
        focus: '#CFEEFF',
        text: '#142A3A',
        iconColor: '#285670',
        iconLight: '#6BBEE6',
        light: '#C1EFFE'
    },
    {
        bg: '#A0B3FF',
        focus: '#CFD2FF',
        text: '#18183C',
        iconColor: '#2C3D79',
        iconLight: '#6E76E7',
        light: '#C3C6FE'
    },
    {
        bg: '#6EE79F',
        focus: '#CCFEDD',
        text: '#133820',
        iconColor: '#297252',
        iconLight: '#67E1A6',
        light: '#C3FED3'
    },
    {
        bg: '#E0FF82',
        focus: '#F5FFCF',
        text: '#2B3612',
        iconColor: '#547229',
        iconLight: '#ACD836',
        light: '#F7FDC0'
    },
    {
        bg: '#FFED78',
        focus: '#F9ECCA',
        text: '#373013',
        iconColor: '#BC9700',
        iconLight: '#E4CB34',
        light: '#FEF4C3'
    },
    {
        bg: 'var(--chakra-colors-noteBg)',
        focus: '',
        text: '',
        iconColor: 'var(--chakra-colors-noteBg)',
        iconLight: 'var(--chakra-colors-noteBg)',
        light: 'var(--chakra-colors-noteBg)'
    }
];

export default commentBg;
